"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../../types");
var isOneOfPages_1 = __importDefault(require("../isOneOfPages"));
function getBackLink() {
    if (isOneOfPages_1.default([types_1.App.Routes.RESULT_MATCH, types_1.App.Routes.AFTERMATCH])) {
        return { link: types_1.App.Routes.RESULTS_LIST, messageId: 'results' };
    }
    if (isOneOfPages_1.default([types_1.App.Routes.MATCH, types_1.App.Routes.TOURNAMENT])) {
        return {
            link: types_1.App.Routes.UPCOMING_LIST,
            messageId: 'upcomingShort',
        };
    }
    if (isOneOfPages_1.default([types_1.App.Routes.OUTRIGHT])) {
        return {
            link: types_1.App.Routes.OUTRIGHTS_LIST,
            messageId: 'outrights',
        };
    }
}
exports.default = getBackLink;
//# sourceMappingURL=getBackLink.js.map